import { View, Pressable } from 'react-native';
import { useRouter } from 'expo-router';
import { Text } from '@/components/ui/text';
import { Icon } from '~/global/components/icon/Icon';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useCurrentLayout } from '~/global/hooks/useCurrentLayout';

export interface PageHeaderProps {
  title: string;
  actions?: ReactNode;
  showBackButton?: boolean;
  className?: string;
}

export const PageHeader = ({
  title,
  actions,
  showBackButton,
  className,
}: PageHeaderProps) => {
  const router = useRouter();
  const layout = useCurrentLayout();

  // Hide back button on sidebar layout
  const shouldShowBackButton =
    layout === 'tabs' && (showBackButton ?? router.canGoBack());

  const handleBack = () => {
    if (router.canGoBack()) {
      router.back();
    } else {
      // If there's no history, navigate to overview
      router.replace('/(overview)');
    }
  };

  return (
    <View
      className={cn(
        'w-full flex flex-row justify-between items-center px-6 pb-4 pt-6',
        className,
      )}
    >
      <View className="flex flex-row items-center gap-4">
        {shouldShowBackButton && (
          <Pressable
            onPress={handleBack}
            accessibilityRole="button"
            className="h-8 w-8 items-center justify-center active:opacity-70"
          >
            <Icon name="ArrowLeft" size={20} className="text-text-primary" />
          </Pressable>
        )}
        <Text className="font-sora-semibold text-lg text-text-primary">
          {title}
        </Text>
      </View>

      {actions && (
        <View className="flex flex-row items-center gap-2">{actions}</View>
      )}
    </View>
  );
};
